import {SET_RESULT_DATA} from '../costants/ActionTypes'

const initialState = {
    visible: false,
    status: "SUCCESS",
    title: "",
    message: "",
    link: "",
    link_tile: "",
    next_link: "",
    next_link_tile: ""
}

const nresult = (state = initialState, action) => {

  switch (action.type) {

      case SET_RESULT_DATA:
          return Object.assign({}, state, action.data)

      default:
        return state
  }
}

export default nresult